import React, { useState } from "react";
import __ from "lodash";
import Alert from "../../../controls/Alert";

const EditPaxValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";

  const checkPax = (pax) => {
    let errors = [];

    if (pax && Array.isArray(pax)) {

      const duplicates = __.filter(pax, (value, index, iteratee) => { return __.find(iteratee, value, index + 1) });
      if (duplicates && Array.isArray(duplicates)) {
        for (let i = 0; i < duplicates.length; i++) {
          const paxRecord = duplicates[i];
          errors.push(`Passenger ${paxRecord.forename} ${paxRecord.surname} is manifested more than once`);
        }
      }
    }

    return errors;
  }

  if (!error) {
    const paxErrors = checkPax(record.passengers);
    if (paxErrors && paxErrors.length > 0) {
      error = true;
      errorMessage = paxErrors[0];
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default EditPaxValidator;
